/**
 * Option buttons sit two to a row on narrow screens. A label with a long word -- "Auto — smallest file
 * (recommended)", "High (Recommended)" -- used to break inside that word ("(recommende|d)") once a half-row
 * button got narrower than the word: the re-edit modal at 390 px and the page at 320 px (UX round 2, UX2-09).
 * Such a label takes the whole row instead, and only where the row is too narrow for the word
 * (`.long-label` under the `@container` rule in convert-options.component.module.scss). Wider rows keep
 * today's two- or three-column grid.
 *
 * 12 characters is where words start to outgrow a half row: measured at the buttons' 15.2 px / 500 weight,
 * 12-character words are 84-94 px and "(recommended)" is 109 px, while a half-row button holds 96 px of text
 * in the 390 px modal and 86 px on a 320 px page.
 */
export const LONG_WORD_CHARS = 12;

/** True when a word in [label] is long enough to break mid-word in a half-row button. */
export function hasLongWord(label: unknown): boolean {
    if (typeof label !== 'string') {
        return false;
    }
    return label.split(/\s+/).some(word => Array.from(word).length >= LONG_WORD_CHARS);
}
